import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import allan from './img/allan.png'
import allanFooter from './img/allan_footer.png'
import laptop from './img/laptop.png'
import Navbar from './Navbar'

class Home extends Component {
  state = {
    company_name: '',
    trial_name_first: '',
    trial_name_last: '',
    trial_phone: '',
    trial_email: '',
  }

  handleChange = ({ target }) => {
    this.setState({
      [target.name]: target.value,
    })
  }

  handleChangeEmail = ({ target }) => {
    this.setState({
      [target.name]: target.value.toLowerCase(),
    })
  }

  handleOnSubmit(e) {
    let error = ''

    if (this.state.company_name.length === 0) {
      error += 'Please enter your Company name. \n'
    }
    if (this.state.trial_name_first.length === 0) {
      error += 'Please enter your first name. \n'
    }
    if (this.state.trial_name_last.length === 0) {
      error += 'Please enter your last name. \n'
    }
    if (this.state.trial_phone.length === 0) {
      error += 'Please enter your phone number. \n'
    }
    if (this.state.trial_email.length === 0) {
      error += 'Please enter your email address. \n'
    }
    if (error.length > 0) {
      this.setState({
        error,
      })
      e.preventDefault()
    }
  }

  render() {
    const {
      company_name,
      trial_name_first,
      trial_name_last,
      trial_phone,
      trial_email,
      error,
    } = this.state
    return (
      <div>
        <Navbar />
        <div className="container-fluid bg-white">
          <div className="row">
            <div className="col-md-12 heading">
              The LLN System that works for you.
            </div>
            <div className="col-md-4 col-md-offset-4 lead-text">
              <p>
                <b>Do you need to:</b>
              </p>
              <ul>
                <li>Assess your learners' LLN levels?</li>
                <li>Analyse the ACSF levels of your courses?</li>
                <li>
                  Compare learner results with the ACSF levels of your courses?
                </li>
                <li>
                  Generate individualised LLN Training Supplements for your
                  learners?
                </li>
              </ul>
            </div>
            <div className="col-md-12 sub-heading">
              Discover more with a free 3-Week trial.
            </div>
          </div>
        </div>
        <div className="row div-height-container paralax">
          <div className="col-md-4 col-md-offset-4 bg-dark">
            <div className="arrow-down" />
            <div className="col-md-12 sub-heading">Get a free 3-Week trial</div>
            {error && (
              <div
                id="alert"
                className="col-md-10 col-md-offset-1 error center alert alert-danger">
                {error}
              </div>
            )}
            <div className="center">
              <form
                className="form-horizontal"
                method="post"
                action="https://api.tlrg.com.au/api/trial-request"
                encType="application/x-www-form-urlencoded"
                onSubmit={this.handleOnSubmit}>
                <div className="form-group">
                  <label className="col-sm-3 control-label">
                    Company Name:
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      id="company_name"
                      name="company_name"
                      placeholder="e.g. The Learning Resources Group"
                      onChange={this.handleChange}
                      value={company_name}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="col-sm-3 control-label">First Name:</label>
                  <div className="col-sm-8">
                    <input
                      id="trial_name_first"
                      name="trial_name_first"
                      type="text"
                      placeholder="e.g. Allan"
                      className="form-control"
                      onChange={this.handleChange}
                      value={trial_name_first}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="col-sm-3 control-label">Last Name:</label>
                  <div className="col-sm-8">
                    <input
                      id="trial_name_last"
                      name="trial_name_last"
                      type="text"
                      placeholder="e.g. Robot"
                      className="form-control"
                      onChange={this.handleChange}
                      value={trial_name_last}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="col-sm-3 control-label">
                    Phone Number:
                  </label>
                  <div className="col-sm-8">
                    <input
                      id="trial_name_last"
                      name="trial_phone"
                      type="text"
                      placeholder="e.g. 1300 221 729"
                      className="form-control"
                      onChange={this.handleChange}
                      value={trial_phone}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="col-sm-3 control-label">Email:</label>
                  <div className="col-sm-8">
                    <input
                      id="trial_name_last"
                      name="trial_email"
                      type="email"
                      placeholder="e.g. sales@tlrg.com.au"
                      className="form-control"
                      onChange={this.handleChangeEmail}
                      value={trial_email}
                      required
                    />
                  </div>
                </div>
                <div className="form-group no-margin-bottom">
                  <div className="col-sm-8 col-sm-offset-3">
                    <button
                      type="submit"
                      className="btn btn-success btn-block padding">
                      Get My Free Trial
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-4 col-md-offset-1 hidden-sm hidden-xs robot-image">
            <img src={laptop} role="presentation" />
          </div>
        </div>
        <div className="bg-white lead-text quote">
          “I find the tool very user friendly. The ability to analyse the
          participant's skill levels and recommended solutions to narrow the
          gaps is a standout feature. The overall functionality and automated
          steps are very helpful. I would have no hesitation recommending the
          tool.”
          <br />
          <br />
          <span
            style={{
              textAlign: 'right',
            }}>
            <b>- Tony Shoebridge, General Manager of Training, Transformed</b>
          </span>
        </div>
        <div className="container-fluid bg-dark">
          <div className="row">
            <div className="col-md-12 heading">
              What can the LLN Robot System do?
            </div>
            <div className="col-md-4 col-md-offset-4 lead-text">
              <p>
                <strong>
                  The LLN Robot System is more than just a test. Each system
                  comes with:
                </strong>
              </p>
              <ul>
                <li className="li-feature">Non-biased online assessment.</li>
                <li className="li-feature">Multi-level testing.</li>
                <li className="li-feature">
                  Option to invite individuals or groups of learners to take the
                  test.
                </li>
                <li className="li-feature">Learner results database.</li>
                <li className="li-feature">Learner answer report.</li>
                <li className="li-feature">
                  Get the ACSF profile for any current national unit of
                  competency.
                </li>
                <li className="li-feature">
                  Get profiles for the courses that you actually deliver.
                </li>
                <li className="li-feature">
                  Analyse the skills gap for your learners.
                </li>
                <li className="li-feature">Customisable forms.</li>
                <li className="li-feature">Easy user account management.</li>
                <li className="li-feature">System analytics.</li>
                <li className="li-feature">Help at your fingertips.</li>
              </ul>
              <p>
                <strong>
                  Want to find out more? Visit the website for more information :
                </strong>
              </p>
            </div>
            <div className="col-md-4 col-md-offset-4">
              <a
                href="https://tlrg.com.au/pages/lln-robot"
                >
                <button
                  type="button"
                  className="btn btn-default btn-lg btn-block padding">
                  Visit the website
                </button>
              </a>
            </div>
          </div>
          <div className="col-md-4 col-md-offset-7 div-wrapper hidden-sm hidden-xs">
            <img src={allan} role="presentation" />
          </div>
        </div>
        <div className="container-fluid bg-white center">
          <img src={allanFooter} role="presentation" />
        </div>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/Home.js